import "./EmptyLayout.scss";
import React from "react";

export const EmptyLayoutComponent = ({ message }) => (
    <div className="umSpEmptyLayout">
        <span>{message}</span>
    </div>
);
